<template>
  <div>
    <page-header title="Dodaj kurs" />
    <form-wrapper
      ref="form"
      :service="Course"
      :formComponent="InnerForm"
      :form.sync="form"
      :errors.sync="errors"
      :getSuccessRoute="getSuccessRoute"
      class="c-box"
      success-message="Kurs dodany"
    />
  </div>
</template>
<script>
import { Course } from '@/api'
import InnerForm from '@/components/forms/CourseForm'

export default {
  data() {
    return {
      form: {},
      errors: {},
      Course,
      InnerForm
    }
  },
  methods: {
    getSuccessRoute: res => ({
      path: `/admin/kursy/szczegoly/${res.data.id}/edytuj/`
    })
  }
}
</script>
